import { AD_MEDIA_MAX_IMAGE_COUNT } from "../../AdMedia";
import { AdPackageKey } from "../schema/AdPackageKey";

export interface AdPackageConstraintsConfig {
  maxImages: number;
  maxDisciplines: number;
}

export const AD_PACKAGE_CONSTRAINT_CONFIGS: Record<
  AdPackageKey,
  AdPackageConstraintsConfig
> = {
  BASIC: {
    maxImages: 10,
    maxDisciplines: 4,
  },
  GENERAL: {
    maxImages: 20,
    maxDisciplines: 6,
  },
  PREMIUM: {
    maxImages: AD_MEDIA_MAX_IMAGE_COUNT,
    maxDisciplines: 6,
  },
  PLATINUM: {
    maxImages: AD_MEDIA_MAX_IMAGE_COUNT,
    maxDisciplines: 6,
  },
};
